var render, staticRenderFns
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e498d1d')) {
      api.createRecord('7e498d1d', component.options)
    } else {
      api.reload('7e498d1d', component.options)
    }
    
  }
}
component.options.__file = "found/views/kms_new/views/order_display/acceptance_order/table.vue"
export default component.exports